<template>
  <div>
    <!-- PowerShell Section -->
    <span id="powerShell" class="anchor"></span>
    <h1>PowerShell(Run As Administrator)</h1>

    <h2>Download the Installer and install xtend</h2>
    <ul>
      <li>Run in PowerShell with admin privileges</li>
      <li>Run within 2 weeks, or the embedded credentials will expire</li>
      <li>Supports only Windows 10+</li>
    </ul>
    <CopyableCommand v-if="versionLoaded && shareKeyLoaded">
      {{ powershellCmd() }}
    </CopyableCommand>
  </div>
</template>

<script>
import CopyableCommand from '@/xvisor/components/CopyableCommand.vue';

export default {
  components: {
    CopyableCommand,
  },
  mounted() {
    this.getXtendVersion();
    this.getShareKey();
  },
  data() {
    return {
      versionLoaded: false,
      shareKeyLoaded: false,
      xtendVersion: '',
      shareKey: '',
    };
  },
  computed: {
    msiName() {
      const ver = this.xtendVersion.replace(/^v/, '');
      return `xtend-${ver}-x86_64.msi`;
    },
    msiUrl() {
      return `https://xvisor.blob.core.windows.net/public/xtend/enterprise/windows/${this.msiName}`;
    },
  },
  methods: {
    getXtendVersion() {
      this.versionLoaded = false;
      this.$http
        .get('/xtends/xtendversion.json')
        .then((response) => { this.xtendVersion = response.data.version; })
        .finally(() => { this.versionLoaded = true; });
    },
    getShareKey() {
      this.shareKeyLoaded = false;
      this.$http
        .get('/xtends/sharedkey.json')
        .then((response) => { this.shareKey = response.data.shareKey; })
        .finally(() => { this.shareKeyLoaded = true; });
    },
    powershellCmd() {
      const psCred = (this.shareKey || '')
        .replace(/`/g, '``')
        .replace(/"/g, '`"');

      // IMPORTANT: keep only the "else {" opener here; we will close it at the end.
      const adminElseOpen = 'if (-not ([Security.Principal.WindowsPrincipal]'
        + '[Security.Principal.WindowsIdentity]::GetCurrent()).IsInRole('
        + '[Security.Principal.WindowsBuiltInRole]::Administrator)) '
        + "{ 'Not Admin' } else { 'Admin check succeeded'";

      const startProcess = '$p=Start-Process -FilePath msiexec.exe -Wait -PassThru -ArgumentList @('
        + '\'/i\',$msi,$credArg,\'/qb\',\'/l*v\',$log'
        + ')';

      const successOrLog = 'if ($code -eq 0 -or $code -eq 3010) { "Install succeeded" } '
        + 'else { "---- Last 200 lines of MSI log ----"; Get-Content $log -Tail 200 }';

      const parts = [
        adminElseOpen,
        '$dir="C:\\Temp\\xtend"',
        'New-Item -ItemType Directory -Force -Path $dir | Out-Null',
        `$msi=Join-Path $dir '${this.msiName}'`,
        '$log=Join-Path $dir \'install.log\'',
        `Invoke-WebRequest -Uri '${this.msiUrl}' -OutFile $msi -ErrorAction Stop`,
        '\'Downloaded xtend installer\'',
        `$cred="${psCred}"`,
        '$credArg=\'CREDENTIAL="\' + ($cred -replace \'"\',\'""\') + \'"\'',
        startProcess,
        '$code=$p.ExitCode',
        '"MSI exit code: $code"',
        successOrLog,
        '}', // closes the else { ... } block
      ];

      return parts.join('; ');
    },
  },
};
</script>

<style scoped>
.anchor {
  top: -75px;
  position: relative;
  z-index: 5;
}
</style>
